export const ADD_APPLIANCE = "ADD_APPLIANCE";
export const DELETE_APPLIANCE = "DELETE_APPLIANCE";
export const EDIT_APPLIANCE = "EDIT_APPLIANCE";
export const UPDATE_APPLIANCE = "UPDATE_APPLIANCE";
export const CLEAR = "CLEAR";